import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import virtual_components from '@devices/settings/device_settings/virtual_components';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import app from '@devices/settings/device_settings/app';
import addon_sensors from '@devices/settings/device_settings/addon_sensors';

export const xt1_device_settings = {
	title: 'settings',
	components: [
		{ title: 'device_name', component: 'device_name_sys' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};

export const xt1_default_settings = [
	schedule_gen_2,
	webhooks_gen_2,
	networks_gen_2_plus,
	bluetooth_gen_2,
	virtual_components,
];

export const xt1_default_and_addon_settings = [
	schedule_gen_2,
	webhooks_gen_2,
	addon_sensors,
	networks_gen_2_plus,
	bluetooth_gen_2,
	virtual_components,
];

export default [...xt1_default_settings, app, share, xt1_device_settings];
